import React from "react";
import PagebuilderHelper from "../../PagebuilderHelper";

function PreviewVideo(props) {
  const element = props.element;

  return (
    <div
      className={`pagebuilder-element-preview pagebuilder-element-preview-video`}
    >
      {PagebuilderHelper.getPreview(element)}
    </div>
  );
}

export default PreviewVideo;
